import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import { useSelector } from 'react-redux';

import { isOrgAdminSelector } from '../../store/selectors';

/**
 * True when the user reaches audit through an Auditor role rather than org admin.
 *
 * Audit v1 is gated on organization-admin membership and grants no RBAC permission, so such a user
 * would get a 403 there. Callers use this to force the unified experience and hide the toggle that
 * would otherwise let them switch to v1.
 */
export const useIsAuditorOnly = (): boolean => {
    const isOrgAdmin = useSelector(isOrgAdminSelector);
    const EnableAuditorRoles = useFeatureFlagValue(Features.EnableAuditorRoles.name);

    return EnableAuditorRoles && !isOrgAdmin;
};
